// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__4MKp1","desabilitar":"OptionSelect_desabilitar__AWCWG","focado":"OptionSelect_focado__9y9DV","novo":"OptionSelect_novo__dmnvr"};